import React, { Fragment } from 'react';
import { instanceOf, func } from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import DeButton from '../../../shared/DeButton';
import SelectionsList from './SelectionsList'
import WarningToast from '../../../shared/WarningToast';
import {
  IMPORT_SUCCESS_MSG,
  IMPORT_ERROR_MSG,
} from '../../../shared/DEConstants'

const ImportSelections = ({
  selectedDefinitions,
  setSelectedDefinition,
  saveTargets,
  validateTargetLabel,
}) => {
  let hasErrorCount = 0;
  let isImportBtnEnabled = 0;
  if (!isEmpty(selectedDefinitions.importValidations)) {
    Object.keys(selectedDefinitions.importValidations).forEach(folder => {
      if (selectedDefinitions.importValidations[folder].errors.length > 0) {
        hasErrorCount += 1;
      }
      if (selectedDefinitions.importValidations[folder].valid.length > 0) {
        isImportBtnEnabled += 1;
      }
    })
  }
  
  const renderNoRecordsMessage = () => {
    return (
      <Fragment>
        {selectedDefinitions.hasSuccess > 0 && <WarningToast
          title={IMPORT_SUCCESS_MSG.title}
          message={IMPORT_SUCCESS_MSG.message}
          type={IMPORT_SUCCESS_MSG.type}
          successCount={selectedDefinitions.hasSuccess}
        />}
        <div className="de--import--no-record">
          Your definitions selected for import will display in this section
        </div>
      </Fragment>
    )
  }

  const renderSelectedDefList = () => {
    return (
      <Fragment>
        {selectedDefinitions.hasSuccess > 0 && <WarningToast
          title={IMPORT_SUCCESS_MSG.title}
          message={IMPORT_SUCCESS_MSG.message}
          type={IMPORT_SUCCESS_MSG.type}
          successCount={selectedDefinitions.hasSuccess}
        />}
        {hasErrorCount > 0 && <WarningToast
          title={IMPORT_ERROR_MSG.title}
          message={IMPORT_ERROR_MSG.message}
          type={IMPORT_ERROR_MSG.type}
        />}
        <div className="de--import-def--list_container">
          <SelectionsList
            data={selectedDefinitions}
            onRemove={setSelectedDefinition}
            validateTargetLabel={validateTargetLabel}
          />
        </div>
      </Fragment>
    )
  }

  return (
    <div className="de--import-root">
      <div className="de--import-header">
        <h3>Import Selections</h3>
      </div>
      <div className="de--import-def--root">
        <div className="de--import-def--card">
          {selectedDefinitions.data.length === 0 ?
            renderNoRecordsMessage() :
            renderSelectedDefList()}
        </div>
      </div>
      <div className="de--import--footer">
        <DeButton
          onClick={() => saveTargets()}
          label="Import"
          disabled={!isImportBtnEnabled}
          fill="secondary"
        />
      </div>
    </div>
  );
};

ImportSelections.propTypes = {
  selectedDefinitions: instanceOf(Object),
  setSelectedDefinition: func,
  saveTargets: func,
  validateTargetLabel: func,
}

export default ImportSelections;
